import { createContext, useContext } from "react";
import type { SignInCredentials } from "../api/accountsApi";
import type { SessionState } from "./sessionMachine";

export interface SessionContextValue {
  readonly session: SessionState;
  /** Rejects with `UiErrorException`; the session changes only on success. */
  readonly signIn: (credentials: SignInCredentials) => Promise<void>;
  readonly signOut: () => Promise<void>;
  readonly retrySessionCheck: () => void;
}

export const SessionContext = createContext<SessionContextValue | null>(null);

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext);
  if (value === null) {
    throw new Error("useSession must be used inside SessionProvider.");
  }
  return value;
}
